var _dec, _class;
import React, { Component, Fragment } from 'react';
import { Box, Callout, Flex, Heading, Text } from 'core/components';
import { Field, RadioGroup, Select, formConsumer } from 'core/form';
import { inject, observer } from 'mobx-react';
function getGuidedModeDimensions({
  type = ''
}, _dimensionList) {
  if (type === 'site') {
    return [{
      label: 'Site Name',
      value: 'i_device_site_name'
    }];
  }
  if (type === 'device') {
    return [{
      label: 'Device Name',
      value: 'i_device_name'
    }];
  }
  if (type === 'country') {
    return [{
      label: 'Country',
      value: 'i_device_site_country'
    }];
  }

  // TODO: Once we're enhancing our dimensions with this parametricType field, we can filter validDimensions here

  return [];
}
let MetricsExplorerGuidedModeBehavior = (_dec = inject('$metrics'), _dec(_class = formConsumer(_class = observer(_class = class MetricsExplorerGuidedModeBehavior extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      measurementDimensions: null,
      guidedModeDimensions: null
    };
    /**
     * Reset form fields to "ignore" state - clears options and validation rules
     */
    this.resetParametricFields = () => {
      const {
        form
      } = this.props;
      form.getField('parametric_overrides.filterField').setOptions();
      form.getField('parametric_overrides.operator').setOptions();
      form.getField('parametric_overrides.filterField').setRules('');
      form.getField('parametric_overrides.operator').setRules('');
    };
    /**
     * Set form fields to require validation
     */
    this.setParametricFieldsRequired = () => {
      const {
        form
      } = this.props;
      form.getField('parametric_overrides.filterField').setRules('required');
      form.getField('parametric_overrides.operator').setRules('required');
    };
    this.onParametricModeChange = (_, value) => {
      if (value === 'ignore') {
        this.resetParametricFields();
      } else {
        this.setParametricFieldsRequired();
      }
    };
    this.onParametricFieldChange = (_, value) => {
      const {
        form,
        filterOperatorOptions,
        standardFilterOperators
      } = this.props;
      const operators = filterOperatorOptions?.[value] ?? standardFilterOperators;
      const parametricOperatorField = form?.getField?.('parametric_overrides.operator');
      const parametricOperator = parametricOperatorField?.getValue();

      // Set operator as first available option if current value is not valid
      if (parametricOperator && !(parametricOperator in operators)) {
        parametricOperatorField?.setValue(Object.keys(filterOperatorOptions)[0]);
      }
    };
    this.getMeasurementDimensions = measurement => {
      const {
        $metrics
      } = this.props;
      if (!measurement) {
        return null;
      }
      const measurementWithMetadata = $metrics.measurementModel(measurement);
      return measurementWithMetadata?.storage?.Dimensions ?? null;
    };
    this.getGuidedModeDimensions = (parametricType, measurementDimensions) => {
      if (!parametricType || !measurementDimensions) {
        return null;
      }
      return getGuidedModeDimensions(parametricType, measurementDimensions);
    };
    this.syncFromProps = prevProps => {
      const {
        measurement,
        parametricType,
        form
      } = this.props;
      const {
        measurementDimensions
      } = this.state;
      const measurementChanged = !prevProps || measurement !== prevProps.measurement;
      const parametricTypeChanged = !prevProps || parametricType?.type !== prevProps.parametricType?.type;
      if (!measurementChanged && !parametricTypeChanged) {
        return;
      }
      const currentMeasurementDimensions = measurementChanged ? this.getMeasurementDimensions(measurement) : measurementDimensions;
      const guidedModeDimensions = this.getGuidedModeDimensions(parametricType, currentMeasurementDimensions);

      // If there are no valid dimensions for guided mode, reset parametric mode to "ignore" and clear fields
      // Do not want to require valid parametric field/operator if there are no valid options to select from
      if (guidedModeDimensions && guidedModeDimensions.length === 0) {
        form.setValue('parametric_mode', 'ignore');
        this.resetParametricFields();
      }
      this.setState(prevState => ({
        ...prevState,
        measurementDimensions: currentMeasurementDimensions,
        guidedModeDimensions
      }));
    };
  }
  componentDidMount() {
    this.syncFromProps();
  }
  componentDidUpdate(prevProps) {
    this.syncFromProps(prevProps);
  }
  render() {
    const {
      availableFiltersConfig,
      parametricMode,
      filterOperatorOptions,
      standardFilterOperators,
      disabled = false,
      measurement,
      form,
      filterFields
    } = this.props;
    const {
      guidedModeDimensions
    } = this.state;

    // Default to first available filter if current value is not valid - this can happen when switching measurements or parametric types and the previously selected filter field is not available
    const selectedParametricFilter = form.getValue('parametric_overrides.filterField') || availableFiltersConfig.availableFilters[0]?.value;
    const parametricOperatorOptions = filterOperatorOptions[selectedParametricFilter] || standardFilterOperators;
    const shouldRenderOperatorField = parametricMode === 'override_all' || parametricMode === 'add_group';
    const hasOptions = Array.isArray(guidedModeDimensions) && guidedModeDimensions.length > 0;
    const {
      measurementDimensions
    } = this.state;
    const activeQueryFilters = filterFields?.filterGroups?.flatMap(filterGroup => filterGroup?.filters?.map(filter => measurementDimensions?.[filter.filterField]?.QueryColumn || filter.filterField) || []);
    const hasOverrideSpecificOption = guidedModeDimensions?.some?.(dimension => activeQueryFilters?.includes(dimension.value)) ?? false;
    return /*#__PURE__*/React.createElement(Flex, {
      flexDirection: "column",
      className: "overflow-auto",
      flexAuto: true
    }, /*#__PURE__*/React.createElement(Heading, {
      level: 6
    }, "Panel Guided Mode Behavior"), /*#__PURE__*/React.createElement(Text, {
      muted: true
    }, "Select the effect you want the user's input to have on this panel"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Field, {
      name: "parametric_mode",
      className: "no-margin",
      onChange: this.onParametricModeChange,
      labelStyle: {
        textTransform: 'none'
      },
      showLabel: false,
      disabled: !measurement || !hasOptions || disabled
    }, /*#__PURE__*/React.createElement(RadioGroup, {
      inline: false,
      disabledOptions: hasOverrideSpecificOption ? [] : ['override_specific']
    }))), measurement && !hasOptions && /*#__PURE__*/React.createElement(Callout, {
      p: 2,
      mt: 2,
      intent: "warning",
      title: "No Valid Guided Mode Dimensions"
    }, "This measurement does not have any valid dimensions for filtering based on the selected Guided Mode category. This panel will ignore any Guided Mode input."), !measurement && /*#__PURE__*/React.createElement(Callout, {
      p: 2,
      mt: 2,
      intent: "danger",
      title: "Missing Valid Query"
    }, "Please select a valid query for this dashboard item before configuring the field and/or operator."), parametricMode !== 'ignore' && measurement && /*#__PURE__*/React.createElement(Callout, {
      p: 2,
      mt: 4
    }, parametricMode === 'override_all' && /*#__PURE__*/React.createElement("p", null, "Ignore panels existing filters and add a new filter group:"), parametricMode === 'override_specific' && /*#__PURE__*/React.createElement("p", null, "Overriding all existing filters that contain:"), parametricMode === 'add_group' && /*#__PURE__*/React.createElement("p", null, "Add a new filter group:"), /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Field, {
      name: "parametric_overrides.filterField",
      disabled: disabled,
      options: guidedModeDimensions,
      onChange: this.onParametricFieldChange
    }, /*#__PURE__*/React.createElement(Select, {
      menuWidth: 350
    })), shouldRenderOperatorField && /*#__PURE__*/React.createElement(Field, {
      name: "parametric_overrides.operator",
      className: "no-margin",
      disabled: disabled,
      options: parametricOperatorOptions
    }, /*#__PURE__*/React.createElement(Select, {
      menuWidth: 350
    })))));
  }
}) || _class) || _class) || _class);
export { MetricsExplorerGuidedModeBehavior as default };